import { REmployeesBrowse } from "@/pages/Layout/views/Expert/views/Employees/browse/REmployeesBrowse";
import { RCompaniesTemplate } from "@/pages/Layout/views/Expert/views/Companies/template/RCompaniesTemplate";
import { RouteConfig } from "vue-router";

export const RExpertEmployees: RouteConfig = {
  path: "employees",
  component: () =>
    import(
      /* webpackChunkName: "expert-employees" */
      "./VExpertEmployees.vue"
    ),
  meta: {
    title: "Employees",
    icon: "people-outline",
    newIcon: "users",
  },
  children: [REmployeesBrowse, RCompaniesTemplate],
};
